export const healthIndicatorQuestionnaire = {
  digitalHeathQuestionnaire: "Questionário de Saúde Digital",
  pdfTitle: "{country} - Questionário de Saúde Digital",
  note:
    "Nota: Os dados do Monitor de saúde digital global serão apresentados publicamente. Como tal, agradecemos que obtenha aprovação para " +
    "submissão de uma entidade governamental relevante (Ministério da Saúde, Agência Digital de Saúde, etc.) e forneça as informações de " +
    "contato do aprovador. Ao sair desta página, as alterações não salvas serão descartadas.",
  contactForm: {
    contactInformation: "Informações de Contato",
    nameOfPersonEnteringData: "Nome da pessoa que introduziu os dados",
    roleOfThePersonEnteringData: "Função da pessoa que introduziu os dados",
    emailOfThePersonEnteringData: "E-mail da pessoa que introduziu os dados",
    nameOfTheApprover: "Nome do aprovador",
    roleOfTheApprover: "Função do aprovador",
    emailOfTheApprover: "Email do aprovador",
    nameOfTheCountryContact: "Nome do contato do país ",
    roleOfTheCountryContact: "Papel do contacto do país",
    emailOfTheCountryContact: "Email do contato do país",
    countrySummary: "Resumo do País",
    organisationOfTheCountryContact: "Organização de contacto do país",
    govtApprovedMessage: "Os dados são aprovados pelo governo?",

    error: {
      nameOfPersonEnteringData:
        "É necessário o nome da pessoa que entra os dados",
      roleOfThePersonEnteringData:
        "O papel da pessoa que entra os dados é necessário",
      email: "Por favor insira um email válido",
      nameOfTheApprover: "Nome da pessoa que aprova os dados é necessário",
      roleOfTheApprover: "O papel da pessoa que aprova os dados é necessário",
      nameOfTheCountryContact: "O contacto do país é obrigatório",
      roleOfTheCountryContact: "O papel do contato do país é necessário",
      countrySummary: "O resumo do país é obrigatório",
      organisationOfTheCountryContact: "Por favor, entre na organização",
    },
    hoverText: {
      nameOfPersonEnteringData: "Entrar o nome da pessoa que entra os dados",
      roleOfThePersonEnteringData:
        "Entrar a função da pessoa que entra os dados",
      email: "Digite o email",
      nameOfTheApprover: "Entrar o nome da pessoa que aprova os dados",
      roleOfTheApprover: "Entrar a função da pessoa que aprova os dados",
      nameOfTheCountryContact: "Contato com o país",
      roleOfTheCountryContact: "Papel do contacto do país",
      organisationOfTheCountryContact: "Enter organização do contacto do país",
    },
  },
  resourceForm: {
    resourceInformation: "Informações sobre recursos",
    note: "Por favor, forneça links para recursos digitais relacionados à saúde para o seu país.",
    exampleFormat: "Exemplo de formato : www.example.com",
    resource: "Recurso {number}",
    errorMessage: "Por favor, digite um link de recurso válido",
  },
  notifications: {
    submit: "Formulário enviado para revisão",
    saveCorrection: "Formulário salvo com sucesso!",
    save: "Formulário salvo com sucesso!",
    publish: "O Data está agora ao vivo",
    download: "Download iniciado com sucesso",
    correctTheHighlightedFields: "Por favor, corrija os campos destacados.",
    somethingWentWrong: "Algo correu mal. Por favor, atualize a página!",
  },
  indicatorDetails: "Detalhes do Indicador",
  indicatorScoreError:
    "A pontuação do indicador e o campo de fundamentação são necessários.",
  rationaleOrSupportingText: "Fundamentação ou texto de apoio",
  downloadPDF: "DESCARREGAR PDF",
  saveAsDraft: "GRAVAR COMO ESBOÇO",
  submit: "ENVIAR",
  save: "Salvar",
  reject: "Rejeitar",
  publish: "Publicar",
  republish: "republicar",
  confirm: "Confirmar",
  cancel: "Cancelar",
  note1: "Estes detalhes serão exibidos publicamente na plataforma GDHM.",
  note2:
    "Estes detalhes não serão apresentados na plataforma GDHM e são para nosso propósito informativo.",
  note3:
    "Somente a pontuação de cada indicador será exibida publicamente na plataforma GDHM.",
  publishConfirmation:
    "Você está prestes a publicar o formulário de índice digital de saúde para {country}. Que não pode ser revertido. Você quer continuar?",
  republishConfirmation:
    "Você está prestes a republicar o formulário de índice de saúde digital para {country}. Isso não pode ser revertido. Você quer continuar?",
  saveConfirmation:
    "Tem certeza de que deseja enviar os dados para {country}? Verifique se as opções selecionadas por você estão refletindo a maturidade em saúde digital do ano atual do país",
  rejectConfirmation:
    "Está prestes a rejeitar o formulário do índice de saúde para {country}. Que não pode ser revertido. Você quer continuar?",
  govtApprovedMessage: "Os dados são aprovados pelo governo?",
  QuestionnaireStateMessage: {
    hasPrefillData:
      "Os dados foram preenchidos previamente no questionário do ano {updatedDate}. Atualize os dados do ano atual e forneça justificativa relevante",
    dataSubmittedAlready:
      "Os dados já foram enviados para o ano atual em {updatedDate}",
    dataPublishedAlready:
      "Os dados do ano atual já foram publicados em {updatedDate}",
  },
};
